<template>
  <div>

    <v-layout
      column
      justify-center
    >
      <v-tabs
        centered="true"
        grow="true"
        fixed-tabs
        v-if="!cargandoGeneral"
        slider-color="#06cbb3"
        color="#E6E6E6"
        @change="cambiarSolapa"
      >
        <v-tab
          :key="'sala'"
          :href="'#tab-sala'"
        >
          <strong>
            <v-icon small>zmdi zmdi-hourglass-alt</v-icon>&nbsp;&nbsp;Sala de espera
          </strong>
        </v-tab>

        <v-tab
          :key="'asignacion'"
          :href="'#tab-asignacion'"
        >
          <strong>
            <v-icon small>zmdi zmdi-check</v-icon>&nbsp;&nbsp;Mis asignaciones
          </strong>
        </v-tab>

        <v-tab-item
          :key="'sala'"
          :value="'tab-sala'"
        >

          <v-progress-linear
            v-slot:progress
            :color="secondary"
            indeterminate
            v-if="cargando"
            height="2"
          ></v-progress-linear>
          <v-subheader
            v-if="!cargando && turnos.length === 0"
            class="subtitle-2"
          >No hay pacientes disponibles</v-subheader>
          <v-expansion-panel
            popout
            expand
            width="600px"
            v-model="panel"
          >
            <v-expansion-panel-content
              v-for="(turno, i) in turnos"
              :key="i"
            >

              <template v-slot:header>
                <v-layout
                  align-center
                  row
                  spacer
                >
                  <v-flex
                    xs4
                    sm1
                    md1
                  >
                    <v-avatar size="36px">
                      <img
                        v-if="turno.paciente.persona.genero && turno.paciente.persona.genero.codigo === 'femenino'"
                        src="/static/img/female.png"
                      >
                      <img
                        v-else
                        src="/static/img/male.png"
                      >
                    </v-avatar>
                  </v-flex>

                  <v-flex
                    sm4
                    md2
                    hidden-xs-only
                  >
                    <a
                      :href="'/pacientes/ver/' + turno.paciente.id "
                      target="_blank"
                    >
                      {{ turno.paciente.persona.apellido }} {{ turno.paciente.persona.nombre }}
                    </a>

                  </v-flex>

                  <v-flex
                    xs5
                    sm1
                    class="text-center"
                  >
                    <v-chip
                      class="ml-0 mt-20"
                      pill
                      small
                      :color="!turno.atendio_medico ? 'green' : 'red'"
                      text-color="white"
                    >
                      <v-avatar left>
                        <v-icon>mdi-av-timer</v-icon>
                      </v-avatar>
                      {{ !turno.atendio_medico ? turno.hora_desde.substr(0, 5) : 'Atendido' }}
                    </v-chip>

                  </v-flex>
                  <v-flex
                    xs1
                    sm1
                    class="text-center"
                  >
                    <v-tooltip bottom>
                      <template
                        v-slot:activator="{ on }"
                        v-if="turno.consulta_virtual"
                      >
                        <v-icon
                          medium
                          color="primary"
                          dark
                          v-on="on"
                        >mdi-video</v-icon>
                      </template>
                      <span>Es consulta virtual</span>
                    </v-tooltip>
                  </v-flex>
                  <v-flex
                    xs1
                    sm1
                    class="text-center"
                  >
                    <v-tooltip bottom>
                      <template
                        v-slot:activator="{ on }"
                        v-if="turno.es_particular === 0"
                      >
                        <v-icon
                          medium
                          color="#Be5504"
                          dark
                          v-on="on"
                        >mdi-credit-card</v-icon>
                      </template>
                      <span>Obra Social</span>
                    </v-tooltip>
                    <small v-if="turno.es_particular === 0">
                      {{turno.paciente.obra_social_actual.obra_social.nombre}}
                    </small>
                    <v-tooltip bottom>
                      <template
                        v-slot:activator="{ on }"
                        v-if="turno.es_particular === 1"
                      >
                        <v-icon
                          medium
                          color="#C00000"
                          dark
                          v-on="on"
                        >money_off</v-icon>
                      </template>
                      <span>Particular pendiente</span>
                    </v-tooltip>
                    <small v-if="turno.es_particular === 1">
                      Particular pendiente
                    </small>
                    <v-tooltip bottom>
                      <template
                        v-slot:activator="{ on }"
                        v-if="turno.es_particular === 2"
                      >
                        <v-icon
                          medium
                          color="success"
                          dark
                          v-on="on"
                        >attach_money</v-icon>
                      </template>
                      <span>Particular paga</span>
                    </v-tooltip>

                  </v-flex>
                  <v-flex
                    no-wrap
                    xs5
                    sm4
                  >
                    <div class="text-xs-center">
                      <span v-html="turno.institucion_practica_horario.institucion_practica.practica.nombre"></span>
                    </div>
                  </v-flex>

                  <v-flex
                    no-wrap
                    xs5
                    sm2
                  >
                    <div class="text-xs-center">
                      <v-btn
                        small
                        color="secondary"
                        dark
                        @click="atender(turno)"
                      >Atender</v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </template>

              <v-card>
                <v-divider class="ma-0"></v-divider>
                <v-card-text class="pa-0">
                  <v-layout wrap>
                    <v-flex
                      xs12
                      sm12
                      lg12
                      class="px-4 py-1"
                    >
                      <span class="subtitle-2 secondary--text subtitulo">
                        <i class="zmdi zmdi-folder-person mr-1"></i> Detalle del turno
                      </span>
                    </v-flex>

                    <v-flex
                      sm6
                      xs12
                      class="px-4 py-1"
                      v-if="turno.fecha_orden !== null"
                      v-bind="colDetalle"
                    >
                      <dt>Fecha Orden</dt>
                      <dd>{{ turno.fecha_orden | formatoFecha  }}</dd>
                    </v-flex>
                    <v-flex
                      v-bind="colDetalle"
                      sm6
                      class="px-4 py-1"
                    >
                      <dt>Orden médica</dt>
                      <dd><a
                          v-if="turno.orden"
                          target="_blank"
                          href="javascript:void(0);"
                          @click="descargarOrden(turno)"
                        >Descargar</a>
                        <span v-if="!turno.orden">Sin orden</span>
                      </dd>
                    </v-flex>
                    <v-flex
                      class="grey--text px-4 py-1"
                      ellipsis
                    >
                      <dt>Observaciones</dt>
                      <dd>
                        {{ turno.observaciones }}
                      </dd>
                    </v-flex>
                  </v-layout>
                  <v-divider class="my-0"></v-divider>

                </v-card-text>
                <v-divider class="my-0"></v-divider>
                <v-card-actions>

                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-tab-item>

        <v-tab-item
          :key="'asignacion'"
          :value="'tab-asignacion'"
        >
          <v-layout
            row
            wrap
            style="max-height: 67px; margin-top: 10px;"
          >
            <v-flex
              xs12
              sm9
            >
              &nbsp;
            </v-flex>
            <v-flex
              xs10
              sm2
            >
              <v-text-field
                v-model="filtrosAsignaciones.fecha"
                label="Fecha"
                type="date"
              ></v-text-field>
            </v-flex>
            <v-flex
              xs2
              sm1
            >
              <v-btn
                id="btnFiltrar"
                dark
                icon
                small
                @click="filtrarAsignaciones()"
                color="secondary"
              >
                <v-icon>zmdi zmdi-search</v-icon>
              </v-btn>

            </v-flex>

          </v-layout>
          <v-data-table
            must-sort
            :headers="headers"
            :items="items"
            :pagination.sync="paginacion"
            :total-items="totalItems"
            :rows-per-page-items="itemsPorPagina"
            :loading="cargando"
            class="elevation-1"
          >
            <v-progress-linear
              v-slot:progress
              color="blue"
              indeterminate
              v-if="cargando"
            ></v-progress-linear>
            <template v-slot:items="props">
              <td
                class="text-xs-center"
                width="20"
                style="padding: 0px;"
              >
                <v-tooltip
                  bottom
                  class="text-md-center text-xs-center"
                >
                  <template
                    v-slot:activator="{ on }"
                    class="text-md-center text-xs-center"
                  >
                    <v-icon
                      small
                      :color="props.item.confirmado_secretaria === 0 ? '#FF0000' : (props.item.confirmado_secretaria === 1 ? '#FFFF00' : '#008000')"
                      dark
                      v-on="on"
                      class="text-md-center text-xs-center"
                    >mdi-checkbox-blank-circle</v-icon>
                  </template>
                  <span v-html="props.item.confirmado_secretaria === 0 ? 'No contactado' : (props.item.confirmado_secretaria === 1 ? 'Contactado' : 'Confirmado')"></span>
                </v-tooltip>
              </td>
              <td class="text-xs-center">{{ props.item.hora_desde | formatoHora}}</td>
              <td class="text-xs-left"><a
                  :href="'/pacientes/ver/' + props.item.paciente_id "
                  target="_blank"
                >{{ props.item.paciente.persona.apellido.concat(', ').concat(props.item.paciente.persona.nombre) }}</a></td>
              <td class="text-xs-left">{{ props.item.institucion_practica_horario.institucion_practica.practica.nombre}}</td>
              <td class="text-xs-left">{{ props.item.institucion_practica_horario.institucion_practica.institucion.nombre}}</td>
              <td class="text-xs-left">{{ props.item.consultorio.nombre}}</td>
            </template>
          </v-data-table>
        </v-tab-item>
      </v-tabs>
    </v-layout>
  </div>
</template>

<script>
import abmMixin from '@/mixins/abm'
import abmListadoMixin from '@/mixins/abmListado'
import Agenda from '@/api/agenda'
import { fechaLocal } from '@/helpers/filtros'
import moment from 'moment'
import _ from 'lodash'

export default {
  name: 'DashboardMedico',
  mixins: [abmMixin, abmListadoMixin],
  computed: {
    usuario () {
      return this.$store.getters.getUser
    },
    acceso () {
      return this.$store.getters.getAcceso
    }
  },
  filters: {
    fechaLocal
  },
  props: {
    titulo: {
      type: String,
      default () {
        return ''
      }
    }
  },
  data () {
    return {
      cronTurnos: null,
      modeloApi: Agenda,
      montarMixin: true,
      filtros: {
        origen: 'dashboard'
      },
      itemSeleccionado: null,
      turnos: [],
      panel: [],
      cargandoGeneral: true,
      headers: [
        { text: '', value: 'hora_desde', sortable: false, align: 'center' },
        { text: 'Hora', value: 'hora_desde', sortable: true, align: 'center' },
        { text: 'Nombre completo', value: 'paciente.persona.apellido', sortable: false },
        { text: 'Practica', value: 'practica_id', sortable: false },
        { text: 'Servicio', value: 'institucion_id', sortable: false },
        { text: 'Consultorio', value: 'consultorio_id', sortable: false }

      ],
      paginacion: { descending: false, sortBy: 'hora_desde' },
      filtrosAsignaciones: {
        origen: 'secretaria',
        pre_asignado_medico_id: null,
        fecha: moment().format('YYYY-MM-DD')
      }
    }
  },
  mounted () {
    let vm = this

    vm.cronTurnos = setInterval(() => {
      vm.filtrarListado()
    }, 60000)
    vm.filtrarAsignaciones()
    vm.cargandoGeneral = false
  },
  beforeDestroy () {
    let vm = this
    clearInterval(vm.cronTurnos)
  },

  methods: {
    filtrarListado () {
      let vm = this

      vm.cargando = true
      Agenda.obtenerTurnosMedico(vm.usuario.id).then(data => {
        vm.turnos = data
        vm.cargando = false
      }, error => {
        vm.mostrarError(error)
        vm.soloLectura = true
        vm.cargando = false
      })
    },
    atender (item) {
      this.$router.push({ name: 'atender', params: { id: item.id } })
    },
    cambiarSolapa (solapa) {
      let vm = this

      console.log(solapa)
      if (solapa === 'tab-asignacion') {
        vm.filtrarAsignaciones()
      }
    },
    filtrarAsignaciones () {
      let vm = this
      this.filtrosAsignaciones.pre_asignado_medico_id = vm.usuario.id
      let _filtros = _.assign({}, vm.filtrosAsignaciones)

      if (vm.cargando) {
        return false
      }

      _filtros.page = vm.paginacion.page
      _filtros.perPage = vm.paginacion.rowsPerPage
      _filtros.orderBy = vm.paginacion.sortBy
      _filtros.sortedBy = vm.paginacion.descending ? 'desc' : 'asc'

      vm.cargando = true
      Agenda.filtrar(_filtros).then(data => {
        vm.items.length = 0
        vm.items = data.data
        vm.totalItems = data.total
        vm.cargando = false
      }, error => {
        vm.mostrarError(error)
        vm.soloLectura = true
        vm.cargando = false
      })
    },
    esVirtual (item) {
      return item.paciente && item.asistido === 0 && item.consulta_virtual !== null && moment().isSameOrBefore(item.fecha, 'day')
    },
    descargarOrden (item) {
      Agenda.descargarOrden(item.id)
    }
  }
}
</script>

<style lang="scss">
.btn-guardar {
  background-color: #a61107 !important;
  border-color: #a61107 !important;
  border-radius: 15px;
  min-height: 34px;
  color: #fff !important;
}
.v-table-chica th {
  color: #424242 !important;
  font-weight: 200 !important;
}
.v-table-chica td {
  color: #9e9e9e !important;
  font-size: 13px !important;
}
.v-table-chica th,
.v-table-chica td {
  padding: 0 10px !important;
}
.v-table-chica thead tr {
  height: 30px !important;
}
.v-table-chica .v-datatable__progress {
  display: none;
}
.v-table-chica tbody tr:nth-child(even) {
  background-color: #fbfbfb !important;
}
.div-check {
  padding: 0 10px;
}
.div-check.grande {
  padding: 0 30px;
}
.subtitulo {
  margin-bottom: 5px;
  margin-top: 5px;
}
dt {
  font-weight: 100;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.54);
}
.blue {
  color: #a61107;
}
#btnFiltrar {
  margin-top: 16px;
  margin-left: 24px;
}
.icon {
  font-size: 20px;
}
</style>
